import GLightbox from "glightbox";
import CC from "cookieconsent";

document.addEventListener("DOMContentLoaded", function (event) {
    const info_more = document.querySelectorAll('.info_teaser_more');

    [...info_more].forEach((info) => {
        info.addEventListener("click", (e) => {
            e.preventDefault();
            info.parentNode.parentNode.parentNode.classList.toggle("info--show");
        });
    })

    const teaser_more = document.querySelectorAll('.teaser_more');

    [...teaser_more].forEach((info) => {
        info.addEventListener("click", (e) => {
            e.preventDefault();
            info.parentNode.parentNode.classList.toggle("teaser--show");
        });
    })

    document.querySelector('.menubutton').addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.toggle("mainnav--show");
    });

    const lightboxes = GLightbox({
        selector: '.popup',
        touchNavigation: true,
        loop: true,
    });

    const galleries = document.querySelectorAll('.teaser--gallery a');

    galleries.forEach((element) => {
        const data = JSON.parse(element.getAttribute('data-images'))
        const lightbox = GLightbox({
            elements: data,
            touchNavigation: true,
            loop: true,
        })
        element.addEventListener('click', () => {
            lightbox.open();
        })
    });

    // Cookie, Matomo
    var _paq = window._paq = window._paq || [];

    function addAnalytics() {
        var u="//matomo.atw.io/";
    _paq.push(['setVisitorCookieTimeout', 2880]); // 2 days
    _paq.push(['setReferralCookieTimeout', 2880]); // 2 days
    _paq.push(['setSessionCookieTimeout', 0]); // session only
        _paq.push(["setTrackerUrl", u+"matomo.php"]);
        _paq.push(["setSiteId", "12"]);
        _paq.push(['enableHeartBeatTimer', 30]);
    _paq.push(["trackPageView"]);
    _paq.push(["enableLinkTracking"]);

        var d=document, g=d.createElement("script"), s=d.getElementsByTagName("script")[0]; g.type="text/javascript";
        g.defer=true; g.async=true; g.src=u+"matomo.js"; s.parentNode.insertBefore(g,s);

        console.log('MATOMO Tracking enabled')
    }

    function optOut(){
        _paq.push(["disableCookies"]);
        _paq.push(["deleteCookies"]);
        //location.reload();

        console.log('MATOMO Tracking disabled')
    }

    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#252e39",
                "text": "#ffffff",
            },
            "button": {
                "background": "#14a7d0",
                "text": "#ffffff"
            }
        },
        "position": "bottom-right",
        "theme": "edgeless",
        "type": "opt-in",
        "content": {
            "message": "Wir verwenden Tracking-Cookies für anonymisierte Nutzungsstatistiken.",
            "allow": "Einverstanden",
            "deny": "Ablehnen",
            "link": "Mehr erfahren",
            "href": "/datenschutz",
            "policy": 'Cookie Einstellungen'
        },
        onInitialise: function (status) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onStatusChange: function (status, chosenBefore) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onRevokeChoice: function () {
            optOut();
        },
    });

});
